import { useTranslation } from "react-i18next";
import InputForm from "../../../../../components/input/input-register/InputForm";
import { EmailIcon, LockIcon } from "../../../../../components/icons";

const AccountInformation = ({
    containerClass,
    formRefs,
    profileData,
    handleChangeProfile,
    errorsProfileData,
}) => {
    const { t } = useTranslation();

    return (
        <div className={containerClass}>
            <p className="tw:!text-[18px] tw:!font-[600] tw:!text-[#282828] tw:!mb-2">
                {t("businessRegister.accountInformation.title")} <span className="tw:text-red-600">*</span>
            </p>
            <div className="tw:!flex tw:!flex-wrap tw:!gap-3 tw:!mb-3">
                <div className="tw:!flex-1">
                    <InputForm
                        innerRef={formRefs.emailRef}
                        type={"text"}
                        suffixClass={"tw:!mb-0 tw:!text-[14px]"}
                        label={t("businessRegister.accountInformation.form.email")}
                        placeholder={t("businessRegister.accountInformation.form.email")}
                        prefixIcon={<EmailIcon />}
                        id={"emailAddress"}
                        name={"email"}
                        value={profileData.email}
                        onChange={handleChangeProfile}
                        isInvalid={errorsProfileData.email}
                        invalidMessage={t(errorsProfileData.email)}
                    />
                </div>
            </div>

            <div className="tw:!flex tw:!flex-wrap tw:!gap-0 tw:md:!gap-3">
                <div className="tw:!w-full tw:md:!w-[calc(50%-0.375rem)] tw:!mb-3 tw:md:!mb-0">
                    <InputForm
                        innerRef={formRefs.passwordRef}
                        type={"password"}
                        suffixClass={"mb-0 tw:!text-[14px]"}
                        label={t("businessRegister.accountInformation.form.password")}
                        placeholder={t("businessRegister.accountInformation.form.password")}
                        prefixIcon={<LockIcon />}
                        id={"password"}
                        name={"password"}
                        value={profileData.password}
                        onChange={handleChangeProfile}
                        isInvalid={errorsProfileData.password}
                        invalidMessage={t(errorsProfileData.password)}
                    />
                </div>

                <div className="tw:!w-full tw:md:!w-[calc(50%-0.375rem)]">
                    <InputForm
                        innerRef={formRefs.confirmPasswordRef}
                        type={"password"}
                        suffixClass={"mb-0 tw:!text-[14px]"}
                        label={t("businessRegister.accountInformation.form.passwordConfirmation")}
                        placeholder={t("businessRegister.accountInformation.form.passwordConfirmation")}
                        prefixIcon={<LockIcon />}
                        id={"confirmPassword"}
                        name={"confirmPassword"}
                        value={profileData.confirmPassword}
                        onChange={handleChangeProfile}
                        isInvalid={errorsProfileData.confirmPassword}
                        invalidMessage={t(errorsProfileData.confirmPassword)}
                    />
                </div>
            </div>
        </div>
    );
};

export default AccountInformation;
